import styled from '@emotion/styled';
import { DFC_PALETTE } from '../../../../../Utils/dfcBrand';
import { SurfaceProp, focusRing, omit } from '../../../../shared/dfcVillage/style';

/** A consent link inside the checkbox row — ink on light, green on dark, never blue. */
export const ConsentLink = styled('a', omit('surface'))<SurfaceProp>`
  font-weight: 700;
  color: ${({ surface }) => (surface.dark ? DFC_PALETTE.green : surface.ink)};
  text-decoration: underline;
  text-underline-offset: 3px;
  ${({ surface }) => focusRing(surface)}
`;
